
export function formatRatingChange(initialRating: number, ratingChange: number): string {
    const roundedInitialRating = Math.round(initialRating);
    const roundedFinalRating = Math.round(initialRating + ratingChange);
    const roundedRatingChange = roundedFinalRating - roundedInitialRating;
    return (roundedRatingChange >= 0 ? "+" : "-") + `${Math.abs(roundedRatingChange).toFixed(0)}`;
}
